"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCalculatedItems;
var _react = require("react");
var ARROW_WIDTH = 5 + 16;
var MORE_WIDTH = 24;
function calculateFullLineWidth(widths) {
  var itemsWidth = widths.reduce(function (result, width) {
    return result + width;
  }, 0);
  return itemsWidth + ARROW_WIDTH * (widths.length - 1);
}
function getFirstVisibleItemIndex(itemsWidths, difference, showFirst) {
  var firstHiddenIndex = showFirst ? 1 : 0;
  var sum = itemsWidths[firstHiddenIndex] - MORE_WIDTH;
  for (var i = firstHiddenIndex + 1; i < itemsWidths.length; i++) {
    if (sum > difference) return i;
    sum += itemsWidths[i] + ARROW_WIDTH;
  }
  return -1;
}
function useCalculatedItems(originItems, widths, containerWidth, showFirst) {
  return (0, _react.useMemo)(function () {
    var widthsArray = Object.values(widths);
    var fullLineWidth = calculateFullLineWidth(widthsArray);
    var difference = fullLineWidth - containerWidth;
    var shortened = difference > 0;
    var firstVisibleItemIndex = shortened ? getFirstVisibleItemIndex(widthsArray, difference, showFirst) : 0;
    var calculatedItems = originItems.slice(firstVisibleItemIndex, originItems.length);
    return {
      calculatedItems: calculatedItems,
      shortened: shortened,
      isContainerOverflowed: firstVisibleItemIndex > -1
    };
  }, [originItems, widths, containerWidth, showFirst]);
}